module.exports = __webpack_public_path__ + "img/mercury-1.8d9e38d0.png";